export default function () { return {} }
